import PromisedResource from './PromisedResource'

export default class MarketingPlatformsResource extends PromisedResource {
  constructor({ remote }) {
    super(remote.query(q => q.findRecords('marketingPlatform')))
  }
}
